module.exports = __webpack_public_path__ + "img/swd.5b6da27d.png";